/* eslint-disable standard/object-curly-even-spacing */
import Vue from 'vue'
import Router from 'vue-router'

import staffRouter from './modules/staff'
import SataffDescRouter from './modules/staff_desc'
import projectRouter from './modules/project'
import ProjectDescRouter from './modules/project_desc'
import {
  RolesRouter,
  RolesDescRouter
} from './modules/roles'

import MonthlyRouter from './modules/monthly'
import ProcessRouter from './modules/process'
import ApprovalRouter from './modules/approval'
import DispatchRouter from './modules/dispatch'
import CheckTimeDescRouter from './modules/checktimeDesc'
import SupplierRouter from './modules/supplier'
import UnivalentRouter from './modules/univalent'
import InvestigateRouter from './modules/investigate'
import TubeRouter from './modules/tube'
import ScrapRouter from './modules/scrap'
import administratorRouter from '@/router/modules/administration'

import {
  FinancialRouter,
  FinancialDescRouter
} from './modules/financial'
import {
  RulesRegRouterDesc,
  RulesRegRouter
} from './modules/rules_regulations'
import todoRouter from './modules/todolist'

import accountRouter from './modules/account'

import {examinationRouter, examinationDescRouter} from './modules/examination'

Vue.use(Router)

/**
 * hidden: true 表示不会在菜单栏中出现
 * redirect: noredirect    当设置 noredirect 的时候该路由不会在面包屑导航中出现
 * alwaysShow: true  如果设置为true则为根目录
 * name:'router-name'             设定路由的名字，一定要填写不然 使用 <keep-alive> 时会出现各种问题
 * meta : {
    title: 'title'               设置路由在侧边栏和面包屑中的名字
    icon: 'svg-name'             设置该路由的图标
    noCache: true                处理是否开启keep-alive -- 暂无使用
    tips:                        处理是否需要提示的问题
  }
 */

export const constantRouterMap = [{
  path: '/login',
  hidden: true,
  component: () => import('@/views/login/index.vue')
},
{
  path: '/404',
  component: () => import('@/views/error_page/page_404'),
  hidden: true
},
{
  path: '/',
  component: () => import('@/views/layout'),
  redirect: '/home',
  children: [{
    path: 'home',
    name: 'homePage',
    meta: {
      title: '首页',
      icon: require('@/assets/slider/home.png'),
      nostyle: true
    },
    component: () => import('@/views/dashboard')
  },
  {
    path: '/map',
    component: () => import('@/views/dashboard/projectmap'),
    hidden: true
  }
  ]
},
// 修改密码
{
  path: '/change',
  component: () => import('@/views/layout'),
  redirect: '/change/pwd',
  hidden: true,
  children: [{
    path: 'pwd',
    name: 'changePwd',
    meta: {
      title: '修改密码'
    },
    component: () => import('@/views/change_pwd/index')
  }]
},
{ // 用于展示首页跳转出来的项目和人员列表
  path: '/other',
  component: () => import('@/views/layout'),
  redirect: '/other/staff',
  hidden: true,
  children: [{
    path: 'staff/:id',
    name: 'OtherStaff',
    meta: {
      title: '员工信息',
      icon: require('@/assets/slider/home.png'),
      nostyle: true
    },
    component: () => import('@/views/other/staff.vue')

  },
  {
    path: 'project',
    name: 'OtherProject',
    meta: {
      title: '项目信息',
      icon: require('@/assets/slider/home.png'),
      nostyle: true
    },
    component: () => import('@/views/other/project.vue')

  }
  ]
},
{
  path: '/vote',
  component: () => import('@/views/layout'),
  redirect: '/vote/add',
  hidden: true,
  children: [{
    path: 'add',
    name: 'voteadd',
    meta: {
      title: '投票'
    },
    component: () => import('@/views/votes/index')
  }]
},
// SupplierRouter,
// UnivalentRouter,
// InvestigateRouter,
// TubeRouter,
// staffRouter,
// ScrapRouter
// examinationRouter

// RulesRegRouterDesc,
// RulesRegRouter
]

export const asyncRoutes = [
  staffRouter,
  projectRouter,

  SataffDescRouter,
  ProjectDescRouter,
  RolesDescRouter,
  MonthlyRouter,

  SupplierRouter,
  UnivalentRouter,
  InvestigateRouter,
  TubeRouter,
  ScrapRouter,

  FinancialRouter,
  FinancialDescRouter,

  ApprovalRouter,
  ProcessRouter,
  RulesRegRouter,
  RulesRegRouterDesc,
  DispatchRouter,
  RolesRouter,
  CheckTimeDescRouter,
  todoRouter,
  accountRouter,
  administratorRouter,
  examinationDescRouter,
  examinationRouter

  // 代办事项

  // 404页面必须最后 !!!
  // { path: '*', redirect: '/404', hidden: true, meta: { title: '404' }}
]
const createRouter = () => new Router({
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap
})

const router = createRouter()

export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

// // Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
// export function resetRouter() {
//   const newRouter = createRouter()
//   router.matcher = newRouter.matcher // reset router
// }
export default router
